import { Domain } from '@utils'

export const stringifyOnClient = (args?: object | undefined) => (
  global.__SERVER__ === true ? args : args && JSON.stringify(args)
)

export const isRetail = (domain: Domain) => domain === 'Retail'
